import { createContext, useContext, useState } from 'react';

const StatisticContext = createContext<any>({
    // Pyramid Age insured
    pyramidAge: '',
    setPyramidAge: () => {},
    isLoadingPyramidAge: '',
    setIsLoadingPyramidAge: () => {},
    // Effectifs moyens
    isLoadingEffectifsMoyens: '',
    setIsLoadingEffectifsMoyens: () => {},
    effectifsMoyens: '',
    setEffectifsMoyens: () => {},
    // Choix adhésion
    isLoadingChoixAdhesion: '',
    setIsLoadingChoixAdhesion: () => {},
    choixAdhesion: '',
    setChoixAdhesion: () => {},
    // Frais réels
    isLoadingFraisReels: '',
    setIsLoadingFraisReels: () => {},
    fraisReels: '',
    setFraisReels: () => {},
    // Effectif en portabilité
    isLoadingEffectifEnPortabilite: '',
    setIsLoadingEffectifEnPortabilite: () => {},
    effectifEnPortabilite: '',
    setEffectifEnPortabilite: () => {},
    // Form managment
    isFormSubmitted: '',
    setIsFormSubmitted: () => {},
});

interface Props {
    children: React.ReactNode;
}

export function StatisticsProvider({ children }: Props) {
    // Pyramid Age insured
    const [isLoadingPyramidAge, setIsLoadingPyramidAge] = useState(true);
    const [pyramidAge, setPyramidAge] = useState();

    // Effectifs moyens
    const [isLoadingEffectifsMoyens, setIsLoadingEffectifsMoyens] = useState(true);
    const [effectifsMoyens, setEffectifsMoyens] = useState();
    // Choix adhésion
    const [isLoadingChoixAdhesion, setIsLoadingChoixAdhesion] = useState(true);
    const [choixAdhesion, setChoixAdhesion] = useState();
    // Choix adhésion
    const [isLoadingFraisReels, setIsLoadingFraisReels] = useState(true);
    const [fraisReels, setFraisReels] = useState();
    // Effectif en portabilite
    const [isLoadingEffectifEnPortabilite, setIsLoadingEffectifEnPortabilite] = useState(true);
    const [effectifEnPortabilite, setEffectifEnPortabilite] = useState();
    // Form managment
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    return (
        <StatisticContext.Provider
            value={{
                // Pyramid Age insured
                pyramidAge,
                setPyramidAge,
                isLoadingPyramidAge,
                setIsLoadingPyramidAge,
                // Effectifs moyens
                isLoadingEffectifsMoyens,
                setIsLoadingEffectifsMoyens,
                effectifsMoyens,
                setEffectifsMoyens,
                // Choix adhésion
                isLoadingChoixAdhesion,
                setIsLoadingChoixAdhesion,
                choixAdhesion,
                setChoixAdhesion,
                // Frais réels
                isLoadingFraisReels,
                setIsLoadingFraisReels,
                fraisReels,
                setFraisReels,
                // Effectif en portabilite
                isLoadingEffectifEnPortabilite,
                setIsLoadingEffectifEnPortabilite,
                effectifEnPortabilite,
                setEffectifEnPortabilite,
                // Form managment
                isFormSubmitted,
                setIsFormSubmitted,
            }}
        >
            {children}
        </StatisticContext.Provider>
    );
}

export const useStatisticsContext = () => useContext(StatisticContext);
